//
//
//
//
//
//

export default {
  name: 'home',
}



// WEBPACK FOOTER //
// ./src/App.vue